export const SET_LOHNANSAETZE = "setLohnAnsaetze";
export const SET_LOHNARTEN = "setLohnArten";
export const SET_HONORAR_STATI = "setHonorarStati";
export const SET_ABRECHNUNGS_PERIODEN = "setAbrechnungsPerioden";
